import type { ThemeUnit } from "../../types";
import { pxToUnit } from "../utils";

const createUnit = (unit: ThemeUnit) =>
  ({
    px: pxToUnit(1, unit),
  }) as const;

export const unitRem = createUnit("rem");
